import { MIN_DATE_TIME_RANGE } from '../../../filters/time-range-filter/TimeRangeFilterConstants';

export function getSelectionBounds(event, granularity) {
    let {
        xAxis: [{ min: start, max: end }],
    } = event;

    start = Math.floor(start);
    end = Math.ceil(end);

    start -= start % granularity; // round down the minimum to the nearest granularity
    end += granularity - (end % granularity); // round up the maximum to the nearest granularity

    // make sure we have at least a minute, and if we have more, always include the next minute
    if (end - start < MIN_DATE_TIME_RANGE) {
        start = end - MIN_DATE_TIME_RANGE;
    }

    // Convert epoch milliseconds to dates for timerange filter
    start = new Date(start);
    end = new Date(end);

    return { start, end };
}
